import Mui5 from "components/mui5";
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import useRemoteConfig from "providers/RemoteConfigProvider/useRemoteConfig";
import { useMultiSelectIds } from "providers/MultiSelectProvider";
import BulkOneRepMaxUploadDialog from "./components/BulkOneRepMaxUploadDialog";

interface AthleteTableBulkOneRepMaxUploadProps {}

function AthleteTableBulkOneRepMaxUpload(props: AthleteTableBulkOneRepMaxUploadProps) {
  const { t } = useTranslation();
  const [dialogOpen, setDialogOpen] = useState(false);
  const isFeatureEnabled = useRemoteConfig("HUB_ENABLE_1RM_BULK_UPLOAD");
  const selectedAthleteIds = useMultiSelectIds();

  const handleOpenDialog = useCallback(() => {
    setDialogOpen(true);
  }, []);

  const handleCloseDialog = useCallback(() => {
    setDialogOpen(false);
  }, []);

  if (!(isFeatureEnabled || process.env.NODE_ENV === "development")) {
    return null;
  }

  const isButtonDisabled = selectedAthleteIds.length === 0;

  return (
    <>
      <Mui5.Button
        color="primary"
        disableElevation
        variant="contained"
        size="medium"
        onClick={handleOpenDialog}
        disabled={isButtonDisabled}
      >
        {t("athlete.bulk_upload_1rm")}
      </Mui5.Button>
      <BulkOneRepMaxUploadDialog
        open={dialogOpen}
        onClose={handleCloseDialog}
        selectedAthleteIds={selectedAthleteIds}
      />
    </>
  );
}

export default AthleteTableBulkOneRepMaxUpload;
